import { useSearchParams } from "react-router-dom";


export default () => {
  const [searchParams] = useSearchParams();

  return searchParams.get("token");
};